import React from 'react';
import { Input, Select } from '../../../components';
import styles from './index.module.css';

export const facilityOptions = (facilities) =>
  (facilities || [])
    .filter((facility) => !facility.disabled)
    .map((facility) => ({
      title: facility.name,
      value: facility.id,
    }));

export const toOrgList = (facilityIds, facilities) =>
  (facilities || [])
    .filter((facility) => facilityIds.includes(facility.id))
    .map((facility) => ({ id: facility.id, name: facility.name }));

export const MultiSiteAdminForm = ({
  values,
  setFieldValue,
  facilities,
  disableIdentity,
}) => {
  const options = facilityOptions(facilities);
  const selectedCount = values.facilityIds?.length || 0;

  return (
    <>
      <div className={styles.field}>
        <label>
          <span className={styles.required}>First Name</span>
          <Input name="firstName" type="text" placeholder="First Name" disabled={disableIdentity} />
        </label>
      </div>
      <div className={styles.field}>
        <label>
          <span className={styles.required}>Last Name</span>
          <Input name="lastName" type="text" placeholder="Last Name" disabled={disableIdentity} />
        </label>
      </div>
      <div className={styles.field}>
        <label>
          <span className={styles.required}>Email</span>
          <Input name="email" type="text" placeholder="Email" disabled={disableIdentity} />
        </label>
      </div>
      <div className={styles.field}>
        <label>
          <span className={styles.required}>Facilities</span>
          <Select
            showSearch
            name="facilityIds"
            value={values.facilityIds || []}
            options={options}
            mode="multiple"
            maxTagCount={2}
            placeholder="Facilities"
            onChange={({ value }) => setFieldValue('facilityIds', value)}
          />
        </label>
        {selectedCount < 1 && (
          <p className={styles.warning}>Select at least one facility.</p>
        )}
      </div>
    </>
  );
};
